import {DomainObject} from 'shared/store';
import {action, computed, observable} from 'mobx';
import {calendarDate} from 'shared/tools';

class NmbrTaxDocument extends DomainObject {
  @observable id;
  @observable documentType;
  @observable taxYear;
  @observable stage;
  @observable createdAt;
  
  @action merge(other) {
    super.merge(other, {
      _dates: ['createdAt']
    });
  }

  @computed get name() {
    return this.documentType.toUpperCase();
  }

  @computed get createdAtView() {
    return calendarDate(this.createdAt);
  }
}

export default NmbrTaxDocument;
